var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03687 0.739014C4.06437 0.739014 0.0368652 4.76651 0.0368652 9.73901C0.0368652 13.7215 2.61312 17.0853 6.19062 18.2778C6.64062 18.3565 6.80937 18.0865 6.80937 17.8503C6.80937 17.6365 6.79812 16.9278 6.79812 16.174C4.53687 16.5903 3.95187 15.6228 3.77187 15.1165C3.67062 14.8578 3.23187 14.059 2.84937 13.8453C2.53437 13.6765 2.08437 13.2603 2.83812 13.249C3.54687 13.2378 4.05312 13.9015 4.22187 14.1715C5.03187 15.5328 6.32562 15.1503 6.84312 14.914C6.92187 14.329 7.15812 13.9353 7.41687 13.7103C5.41437 13.4853 3.32187 12.709 3.32187 9.26651C3.32187 8.28776 3.67062 7.47776 4.24437 6.84776C4.15437 6.62276 3.83937 5.70026 4.33437 4.46276C4.33437 4.46276 5.08811 4.22651 6.80937 5.38526C7.52937 5.18276 8.29437 5.08151 9.05937 5.08151C9.82437 5.08151 10.5894 5.18276 11.3094 5.38526C13.0306 4.21526 13.7844 4.46276 13.7844 4.46276C14.2794 5.70026 13.9644 6.62276 13.8744 6.84776C14.4481 7.47776 14.7969 8.27651 14.7969 9.26651C14.7969 12.7203 12.6931 13.4853 10.6906 13.7103C11.0169 13.9915 11.2981 14.5315 11.2981 15.3753C11.2981 16.579 11.2869 17.5465 11.2869 17.8503C11.2869 18.0865 11.4556 18.3678 11.9056 18.2778C13.6922 17.6746 15.2447 16.5263 16.3446 14.9945C17.4445 13.4628 18.0363 11.6247 18.0369 9.73901C18.0369 4.76651 14.0094 0.739014 9.03687 0.739014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0368652 0.739014)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a56787e8a6d0f0ccaaa726ea451fcdff.svg";
export { ForwardRef as ReactComponent };